var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsEditRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.475 6.69375L11.2875 3.54375L12.3375 2.49375C12.625 2.20625 12.9783 2.0625 13.3973 2.0625C13.8158 2.0625 14.1688 2.20625 14.4563 2.49375L15.5063 3.54375C15.7938 3.83125 15.9438 4.17825 15.9563 4.58475C15.9688 4.99075 15.8313 5.3375 15.5438 5.625L14.475 6.69375ZM3 15.75C2.7875 15.75 2.6095 15.678 2.466 15.534C2.322 15.3905 2.25 15.2125 2.25 15V12.8812C2.25 12.7812 2.26875 12.6845 2.30625 12.591C2.34375 12.497 2.4 12.4125 2.475 12.3375L10.2 4.6125L13.3875 7.8L5.6625 15.525C5.5875 15.6 5.50325 15.6562 5.40975 15.6937C5.31575 15.7312 5.21875 15.75 5.11875 15.75H3Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsEditRounded);
export default __webpack_public_path__ + "static/media/material-symbols_edit-rounded.f1c2da5f163e6e6a40325c19f8fef0cf.svg";
export { ForwardRef as ReactComponent };